import React, { PureComponent } from 'react';
import memoize from 'memoize-one';

import styled from 'styled-components';

import TabComponent from './tab-component';
import CreateVibe from './create-vibe';
import VibeList from './vibe-list';

const Container = styled.div`
  width: inherit;
  height: inherit;
  margin: 0 auto;
`;

const TABS = [
  {
    id: 'create-vibe',
    label: 'Create Vibe',
    Component: CreateVibe,
  },
  {
    id: 'vibe-list',
    label: 'Vibe List',
    Component: VibeList,
  },
];

const getTabs = memoize((tabs, studentId) =>
  tabs.map(tab => ({
    ...tab,
    link: `/user-vibe/${tab.id}`,
  })),
);

export default class UserVibe extends PureComponent {
  render() {
    const { activeTab } = this.props;
    const tabs = getTabs(TABS);

    return <Container>{<TabComponent tabs={tabs} activeTab={activeTab} />}</Container>;
  }
}

UserVibe.defaultProps = {
  activeTab: 'create-vibe',
};
